"use client";

import { useEffect } from "react";
import { useAnalytics } from "./AnalyticsProvider";
import type { AnalyticsEvent } from "@/lib/analytics";

interface TrackPageViewProps {
  event: AnalyticsEvent;
}

export function TrackPageView({ event }: TrackPageViewProps) {
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent(event);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
